import { useAnimations } from '@react-three/drei';
import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';

export const Druid = () => {
  const gltf = useGLTF('/models/characters/Druid.glb');
  const { actions } = useAnimations(gltf.animations, gltf.scene);

  useEffect(() => {
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
      }
    });
  }, [gltf]);

  useEffect(() => {
    actions['Idle']?.reset().fadeIn(0.5).play();
  }, [actions]);

  return (
    <primitive
      object={gltf.scene}
      position={[-1, 0, 0.5]}
      rotation={[0, 1, 0]}
      scale={[0.334, 0.334, 0.334]}
      castShadow
    />
  );
};
